import { EditableSharePermissionList, RoleType } from "@/constants/share";
import { getMeetingPermission } from "@/services/summary";
import { getUser } from "@/store/user.store";
import summaryCommonStore from "@/store/summaryCommon.store";
import { useState, useEffect } from "react";
import { message } from "antd";
const useGetPermission = (streamName: string) => {
  const [mySharePermission, setMySharePermission] = useState(RoleType.Viewer);
  const fetchMeetingPermission = async () => {
    try {
      const res = await getMeetingPermission(streamName);
      setMySharePermission(res.data.sharePermission);
      getUser(true);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      console.log('getMeetingPermission error', error);
      // 录制信息已删除
      if (error?.errCode === 40002103) {
        message.error("录制信息已删除");
        summaryCommonStore.getState().setErrorStatus(40002103);
        summaryCommonStore.getState().setShowCompanyError(true);
      }
    }
  };

  useEffect(() => {
    if (!streamName) return;
    fetchMeetingPermission();
  }, [streamName]);

  const editable = EditableSharePermissionList.includes(mySharePermission);

  return {
    editable,
    mySharePermission,
    fetchMeetingPermission,
  };
};

export default useGetPermission;
